export default "__VITE_ASSET__C30P2QiS__"